import { Injectable, forwardRef, Inject } from '@angular/core';

import { ApiService }        from '../api/api.service';
import { SessionService } from '../sessions/session.service';
import { UserModel }         from './models/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor (
    @Inject(forwardRef(() => ApiService)) private apiService    : ApiService,
    @Inject(forwardRef(() => SessionService))
    private sessionService: SessionService
  ) {}

  get ( id = this.sessionService.base().user_id ) : ng.IPromise<UserModel> {
    return this.apiService.get('/user', id);
  }

  patch ( user : UserModel ) : ng.IPromise<UserModel> {
    return this.apiService.patch('/user', user, 'user');
  }
}
